import type { SiteName } from './site-config';

const createShorthands = <T extends string, K extends T | SiteName>(
  input: Record<T, K[]>,
) => input;

export const siteShorthands = createShorthands({
  'candidate-seek-all': ['candidate-seek-au', 'candidate-seek-nz'],
  'candidate-jobsdb-all': ['candidate-jobsdb-hk', 'candidate-jobsdb-th'],
  'candidate-jobstreet-all': [
    'candidate-jobstreet-sg',
    'candidate-jobstreet-id',
    'candidate-jobstreet-ph',
    'candidate-jobstreet-my',
  ],
  'candidate-all': [
    'candidate-seek-all',
    'candidate-jobsdb-all',
    'candidate-jobstreet-all',
  ],
  'employer-anz': ['employer-seek-au', 'employer-seek-nz'],
  'employer-asia': [
    'employer-seek-hk',
    'employer-seek-th',
    'employer-seek-id',
    'employer-seek-my',
    'employer-seek-ph',
    'employer-seek-sg',
  ],
  'employer-all': ['employer-anz', 'employer-asia'],
});

export type SiteShorthand = keyof typeof siteShorthands;
export const isSiteShorthand = (value: string): value is SiteShorthand =>
  value in siteShorthands;
